<template>
    <span>{{computedLabel}}</span>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop, Inject } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppTableHeaderLabel extends AppComponent {
  // 上位のテーブルコンポーネントで公開されたテーブルデータを参照
  @Inject('_app_table') table;

  @Prop({require: true, default: null})
  prop;

  @Prop({require: false, default: null})
  label;

  get computedLabel () {
    // label が指定されていない場合は、プロパティ名に対応するスキーマのラベル定義を参照する。
    if (this.label === null) {
      if (this.table && this.table.schema && (this.prop in this.table.schema.props)) {
        return this.table.schema.props[this.prop].label;
      }
    }
    return this.label;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/table/AppTableHeaderLabel.vue